import React from "react";
import dayjs from "dayjs";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import CloseIcon from "../../../Common/Svgs/CloseIcon";

const EditedWeightModal = ({ visible, onCancel, data }) => {
  if (!data) return null;

  const actType = +(data?.activityType || data?.type || 1);
  const currentWeight =
    actType === 2 ? data?.weightDelivered : data?.weightCollected;
  const unit = data?.unit
    ? data.unit.replace(/^[0-9.]+\s*|\bper\b\s*/i, "")
    : "Kg";

  const initialWeightDisplay =
    data?.initialWeight !== undefined && data?.initialWeight !== null
      ? `${data.initialWeight} ${unit}`
      : "--";

  const modifiedWeightDisplay =
    currentWeight !== undefined && currentWeight !== null
      ? `${currentWeight} ${unit}`
      : "--";

  const formattedDate = data?.editedAt
    ? dayjs(data.editedAt).format("DD-MM-YYYY, hh:mm a")
    : "--";

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px">
      <div className="p-6">
        <div className="flex items-center justify-between pb-4">
          <h2 className="font-poppins font-medium text-base text-black">
            Edited Weight
          </h2>
          <button
            type="button"
            className="cursor-pointer focus:outline-none"
            onClick={onCancel}
          >
            <CloseIcon className="stroke-dark-gray w-6 h-6" />
          </button>
        </div>

        <div className="bg-background rounded-lg p-4">
          <p className="font-poppins font-medium text-sm text-black mb-2">
            {data?.produce || "Produce"}
          </p>

          <div className="border-b border-light-grey mb-2" />

          <div className="flex flex-col gap-y-2">
            <div className="flex items-center justify-between">
              <span className="font-aileron font-normal text-sm text-dark-grey">
                Initial weight
              </span>
              <span className="font-aileron font-semibold text-sm text-black">
                {initialWeightDisplay}
              </span>
            </div>

            <div className="flex items-center justify-between">
              <span className="font-aileron font-normal text-sm text-dark-grey">
                Modified weight
              </span>
              <span className="font-aileron font-semibold text-sm text-black">
                {modifiedWeightDisplay}
              </span>
            </div>

            <div className="flex items-start justify-between gap-x-4">
              <span className="font-aileron font-normal text-sm text-dark-grey shrink-0">
                Reason
              </span>
              <span className="font-aileron font-semibold text-sm text-black text-right">
                {data?.editReason || "--"}
              </span>
            </div>

            <div className="flex items-center justify-between">
              <span className="font-aileron font-normal text-sm text-dark-grey">
                Edited By
              </span>
              <span className="font-aileron font-semibold text-sm text-black">
                {data?.editedByName || "--"}
              </span>
            </div>

            <div className="flex items-center justify-between">
              <span className="font-aileron font-normal text-sm text-dark-grey">
                Date
              </span>
              <span className="font-aileron font-semibold text-sm text-black">
                {formattedDate}
              </span>
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default EditedWeightModal;
